module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/5b412bcf31537299f5005ae7d3153c3c.png";